module.exports = __webpack_public_path__ + "img/gateio.37102bc4.png";